import React from "react";
import Section from "./Section";
import {
  Pill,
  FileSignature,
  Building2,
  Download,
  GraduationCap,
  Award,
  CreditCard,
  Stethoscope,
} from "lucide-react";
import { X_PADDING } from "../constants";
import Page from "./Page";

const MentalPsychiatry = () => {
  return (
    <Page name="Mental Psychiatry Officer">
      <div className={`w-full bg-white pt-8 pb-16 ${X_PADDING}`}>
        
        {/* Mental Psychiatry Officer */}
        <Section name="Mental Health" description="" />
        <div className="w-full mx-auto">

          {/* Three Cards - Now on the main page */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <InfoCard
              icon={GraduationCap}
              title="Qualification"
              description="Bachelor of Science in Mental Health & Clinical Psychiatry."
            />
            <InfoCard
              icon={Award}
              title="Zambia Qualification Authority"
              description="Level 7"
            />
            <InfoCard
              icon={CreditCard}
              title="Minimum Credit requirement"
              description="480 credits or 4800 notional Hours"
            />
          </div>

          {/* Image + Paragraph Section  */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 mb-16">
            {/* Left - Image */}
            <div className="overflow-hidden shadow-lg h-[350px]">
              <img
                src="/images/img.jpg"
                alt="Clinical Officer in Practice"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* Right - Area of Practice Paragraph */}
            <div className="bg-[#f8fafb]  p-6 md:p-8 border border-[#eef1f4] h-[350px] flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-[#1477c2] p-2 rounded-lg flex-shrink-0">
                  <Stethoscope className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-[#16365c]">
                  Area of Practice
                </h3>
              </div>
              <p className="text-[#16365c] leading-relaxed overflow-y-auto">
                General Practitioner in medicine, provide mental health and
                Psychiatry, rehabilitative service care services in all aspects
                of mental health, treats complicated clinical psychiatry cases
                at all levels of health care; primary, secondary and
                tertiary/teaching/specialist hospitals .
              </p>
            </div>
          </div>

          {/* Detailed breakdown - Professional Practice Details */}
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-[#16365c] mb-3">
              Professional Practice Details
            </h2>
            <p className="text-gray-500">
              Regulatory and administrative scope for the Clinical Officer -
              General cadre.
            </p>
            <div className="w-16 h-1 bg-[#1477c2] mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
            {detailItems.map(({ icon: Icon, label, detail }) => (
              <div
                key={label}
                className="border border-[#eef1f4] rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 p-6 group"
              >
                <div className="w-11 h-11 rounded-lg bg-[#16365c]/10 flex items-center justify-center mb-4 group-hover:bg-[#1477c2] transition-colors duration-200">
                  <Icon
                    className="w-5 h-5 text-[#16365c] group-hover:text-white transition-colors duration-200"
                    strokeWidth={1.75}
                  />
                </div>
                <h4 className="font-semibold text-[#16365c] mb-2">{label}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {detail}
                </p>
              </div>
            ))}
          </div>

          {/* CTA banner for the scope of practice document */}
          <div className="bg-gradient-to-r from-[#16365c] via-[#1477c2] to-[#1b9de3] rounded-lg p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-white text-xl font-bold mb-1">
                Full Scope of Practice
              </h3>
              <p className="text-white/80 text-sm max-w-md">
                Download the official scope of practice document for the
                Clinical Officer - General cadre.
              </p>
            </div>
            <button className="flex items-center gap-2 bg-white text-[#16365c] font-semibold px-6 py-3 rounded-lg hover:bg-[#eef1f4] transition-colors duration-200 whitespace-nowrap">
              <Download className="w-4 h-4" strokeWidth={2} />
              Download Document
            </button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default MentalPsychiatry;

const InfoCard = ({ icon: Icon, title, description }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-[#eef1f4] group hover:shadow-lg transition-shadow duration-300">
      {/* Header with Icon */}
      <div className="bg-[#f8fafb] p-4 flex items-center gap-3 border-b border-[#eef1f4]">
        <div className="w-10 h-10 rounded-lg bg-[#16365c]/10 flex items-center justify-center group-hover:bg-[#1477c2] transition-colors duration-200">
          <Icon
            className="w-5 h-5 text-[#16365c] group-hover:text-white transition-colors duration-200"
            strokeWidth={1.75}
          />
        </div>
        <h3 className="text-base font-bold text-[#16365c]">{title}</h3>
      </div>

      {/* Body */}
      <div className="p-5">
        <p className="text-gray-600 leading-relaxed text-sm">{description}</p>
      </div>
    </div>
  );
};

// Detail items for the lower section
const detailItems = [
  {
    icon: Pill,
    label: "Drug Prescription",
    detail: "Non.",
  },
  {
    icon: FileSignature,
    label: "Statutory & Legal Signatory",
    detail:
      "Cannot sign certain statutory or legal documents unless under consultation with, or as prescribed by, a medical doctor.",
  },
  {
    icon: Building2,
    label: "Administration",
    detail:
      "Legally allowed to independently supervise and run Class C facilities, including health posts, health centres and Juniors.",
  },
];
